type ComponentWithStatics<Styles = any, I18n = any> = {
  styles: Styles;
  i18n: I18n;
}

type PartialProps<Styles = {}, I18n = {}> = {
  styles?: Partial<Styles>;
  i18n?: Partial<Styles>;
}

export default function getComponentStatics<Styles = {}, I18n = {}>(
  Component: ComponentWithStatics,
  props?: PartialProps
): ComponentWithStatics<Styles, I18n> {
  return {
    styles: {
      ...Component.styles,
      ...(props && props.styles ? props.styles : {}),
    },
    i18n: {
      ...Component.i18n,
      ...(props && props.i18n ? props.i18n : {}),
    },
  }
}